import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CheckCircle } from "lucide-react";
export const CTASection = () => {
  return <section className="py-12 md:py-16 lg:py-[10px]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-brand-teal to-brand-coral rounded-3xl p-6 md:p-8 lg:p-12 text-white">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">Pronto para multiplicar seu faturamento?</h2>
          <p className="text-lg md:text-xl mb-2 opacity-90">
            Junte-se a centenas de e-commerces que já aumentaram suas vendas
          </p>
          <p className="text-sm md:text-base lg:text-lg mb-6 md:mb-8 opacity-80">
            Configure seu programa em menos de 10 minutos e veja os primeiros resultados em 24h
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6 md:mb-8">
            <Button size="lg" variant="secondary" className="text-base md:text-lg px-6 md:px-8 py-3 md:py-4 bg-white text-brand-teal hover:bg-gray-100 min-h-[44px]" asChild>
              <Link to="/signup">
                Começar Agora - Grátis <ArrowRight className="ml-2 h-4 w-4 md:h-5 md:w-5" />
              </Link>
            </Button>
          </div>
          
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            <Badge variant="secondary" className="bg-white/20 text-white border-white/30 text-xs md:text-sm px-3 md:px-4 py-2">
              <CheckCircle className="w-3 h-3 md:w-4 md:h-4 mr-2" />
              Sem compromisso
            </Badge>
            <Badge variant="secondary" className="bg-white/20 text-white border-white/30 text-xs md:text-sm px-3 md:px-4 py-2">
              <CheckCircle className="w-3 h-3 md:w-4 md:h-4 mr-2" />
              Configuração gratuita
            </Badge>
            <Badge variant="secondary" className="bg-white/20 text-white border-white/30 text-xs md:text-sm px-3 md:px-4 py-2">
              <CheckCircle className="w-3 h-3 md:w-4 md:h-4 mr-2" />
              Suporte incluído
            </Badge>
          </div>
        </div>
      </div>
    </section>;
};